import { PayloadAction } from '@reduxjs/toolkit';
import { ServiceDataResponse } from './types';
import { initialState } from '.';

export const reducers = {
  getServiceData(state) {
    state.isLoading = true;
  },

  getServiceDataSuccess(state, action: PayloadAction<ServiceDataResponse>) {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload;
  },

  getServiceDataFail(state, action: PayloadAction<unknown>) {
    state.isLoading = false;
    state.data = initialState.data;
    state.error = action.payload;
  },

  clearServiceData(state) {
    state.isLoading = initialState.isLoading;
    state.data = initialState.data;
    state.error = initialState.error;
  },
};
